import { useLimitSummary } from 'components/common-form/sidePanel/docToolbar/summary/hooks/useLimitSummary';
import {
  SecondarySummaryBlock,
  SummaryFieldRowSecondary,
} from 'components/common-form/sidePanel/docToolbar/summary/ShareButtonSecondary';
import { FC } from 'react';

interface LimitSecondarySummaryModalProps {
  tabId: string;
  summary?: string;
}

export const LimitSecondarySummaryModal: FC<LimitSecondarySummaryModalProps> = ({ tabId, summary }) => {
  const limitSummaryMailRequest = useLimitSummary(tabId);

  return (
    <>
      <SecondarySummaryBlock title="Order">
        <SummaryFieldRowSecondary labelKey="orderId">{limitSummaryMailRequest.limitOrderId}</SummaryFieldRowSecondary>
        <SummaryFieldRowSecondary>
          <span>{summary ?? null}</span>
        </SummaryFieldRowSecondary>
      </SecondarySummaryBlock>
      <SecondarySummaryBlock title="Client">
        <SummaryFieldRowSecondary labelKey="client">{limitSummaryMailRequest.limitClient}</SummaryFieldRowSecondary>
        <SummaryFieldRowSecondary labelKey="custodian">
          {limitSummaryMailRequest.limitCustodian}
        </SummaryFieldRowSecondary>
      </SecondarySummaryBlock>
      <SecondarySummaryBlock title="Product">
        <SummaryFieldRowSecondary labelKey="isin">{limitSummaryMailRequest.limitIsin}</SummaryFieldRowSecondary>
        <SummaryFieldRowSecondary labelKey="fileCode">{limitSummaryMailRequest.limitFileCode}</SummaryFieldRowSecondary>
        <SummaryFieldRowSecondary labelKey="ric">{limitSummaryMailRequest.limitRic}</SummaryFieldRowSecondary>
      </SecondarySummaryBlock>
      <SecondarySummaryBlock title="Trade information">
        <SummaryFieldRowSecondary labelKey="quantity">{limitSummaryMailRequest.limitQuantity}</SummaryFieldRowSecondary>
        <SummaryFieldRowSecondary labelKey="sglimit">
          {limitSummaryMailRequest.limitOrderLimit}
        </SummaryFieldRowSecondary>
        <SummaryFieldRowSecondary labelKey="cpCashAmount">
          {limitSummaryMailRequest.limitCashAmount}
        </SummaryFieldRowSecondary>
        <SummaryFieldRowSecondary labelKey="tradeWay">{limitSummaryMailRequest.limitTradeWay}</SummaryFieldRowSecondary>
        <SummaryFieldRowSecondary labelKey="settlementUnit">
          {limitSummaryMailRequest.limitSettlementUnit}
        </SummaryFieldRowSecondary>
      </SecondarySummaryBlock>
      <SecondarySummaryBlock title="Dates">
        <SummaryFieldRowSecondary labelKey="settlementDate">
          {limitSummaryMailRequest.limitSettlementDate}
        </SummaryFieldRowSecondary>
      </SecondarySummaryBlock>
    </>
  );
};

LimitSecondarySummaryModal.displayName = 'LimitSecondarySummaryModal';
